<section class="d-flex justify-content-center mb-0">

  <!-- big -->
  <div class="d-none d-md-flex justify-content-center mb-0 big">
    <mat-form-field class="w-75">
      <mat-select [(ngModel)]="activeList" (selectionChange)="onSelectionChange(activeList)">
        <mat-optgroup *ngFor="let studium of zapisneListy" [label]="studium.name">
          <mat-option *ngFor="let zapisnyList of studium.zapisneListy" [value]="zapisnyList">
            {{zapisnyList.name}}
          </mat-option>
        </mat-optgroup>
      </mat-select>
    </mat-form-field>
  </div>

  <!-- small -->
  <div class="d-flex d-md-none justify-content-center mb-0 w-100">
    <mat-form-field class="w-100 mb-0">
      <mat-select [(ngModel)]="activeList" (selectionChange)="onSelectionChange(activeList)">
        <mat-optgroup *ngFor="let studium of zapisneListy" [label]="studium.name">
          <mat-option *ngFor="let zapisnyList of studium.zapisneListy" [value]="zapisnyList">
            {{zapisnyList.name}}
          </mat-option>
        </mat-optgroup>
      </mat-select>
    </mat-form-field>
  </div>

</section>
